import { useState } from 'react';
import axios from '@helpers/axios';
import type { ErrorMessage } from '@theme/theme';

export interface UserStatsResponse {
  clipCount: number;
  userId: string;
}

export const useUserStats = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<ErrorMessage | null>(null);

  const getStats = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get('/v2/users/my/stats');
      if (response.status === 200) {
        return response.data;
      }
    } catch (err) {
      setError({ message: 'Failed to fetch user stats' });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    getStats,
  };
};

export const usePlayerGameStats = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<ErrorMessage | null>(null);

  const getPlayerGameStats = async (
    claimedPlayerId: string,
    teamGameId: string
  ) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `/v2/claimed_players/${claimedPlayerId}/game/${teamGameId}/stats`
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (err) {
      setError({ message: "Failed to fetch user's game stats" });
      throw new Error('Failed to fetch player game stats');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    getPlayerGameStats,
  };
};
